var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10276",
    "data-name": "Group 10276",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.566,
    height: 22.593,
    viewBox: "0 0 22.566 22.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4074",
    "data-name": "Rectangle 4074",
    width: 22.566,
    height: 22.593,
    fill: "#597931"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10275",
    "data-name": "Group 10275",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44420",
    "data-name": "Path 44420",
    d: "M22.566,11.857a2.192,2.192,0,0,1-1.184,1.353,2.126,2.126,0,0,1-.878.182c-.229,0-.281.092-.281.3.006,2.066,0,4.132,0,6.2a2.659,2.659,0,0,1-.572,1.809,2.349,2.349,0,0,1-1.844.888c-1.2.005-2.4,0-3.595,0a.676.676,0,0,1-.752-.748c0-1.706-.013-3.411.005-5.117a1.135,1.135,0,0,0-1.208-1.207c-.66.03-1.323,0-1.985.007A1.062,1.062,0,0,0,9.17,16.64q0,2.547,0,5.095c0,.632-.227.857-.866.857-1.169,0-2.338,0-3.507,0a2.423,2.423,0,0,1-2.361-2.238c-.071-1.219-.019-2.439-.029-3.659-.009-1.007-.005-2.014,0-3.021,0-.192-.051-.265-.258-.279A2.082,2.082,0,0,1,.042,11.678,2.108,2.108,0,0,1,.7,9.7q2.89-2.88,5.772-5.769L9.718.685A2.434,2.434,0,0,1,10.344.2a2.276,2.276,0,0,1,2.509.414c.323.361.683.689,1.026,1.032q3.953,3.953,7.908,7.9a2.889,2.889,0,0,1,.778,1.157Zm-3.72,4.566c0-1.235,0-2.47,0-3.705a.663.663,0,0,1,.69-.7c.3,0,.6,0,.9,0a.749.749,0,0,0,.75-.44.763.763,0,0,0-.2-.864q-4.553-4.555-9.108-9.108a.725.725,0,0,0-1.125,0q-4.563,4.56-9.124,9.122a.715.715,0,0,0-.2.841.733.733,0,0,0,.72.452c.272.007.544,0,.816,0,.573,0,.816.244.816.818q0,3.573,0,7.146a1.131,1.131,0,0,0,1.258,1.254c.823,0,1.647-.007,2.47.005.22,0,.27-.075.269-.28-.007-1.345,0-2.691,0-4.036a5.4,5.4,0,0,1,.03-.594,2.459,2.459,0,0,1,2.417-2.194c.728-.005,1.456,0,2.183,0a2.224,2.224,0,0,1,.94.2,2.462,2.462,0,0,1,1.5,2.393c.01,1.419,0,2.838,0,4.257,0,.171.038.251.232.249.853-.009,1.706,0,2.558-.006a1.121,1.121,0,0,0,1.206-1.218q0-1.8,0-3.594",
    transform: "translate(0 0)",
    fill: "#597931"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.5c3e231de0a44bec6b77b77555918f01.svg";
export { ForwardRef as ReactComponent };